import { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import bgGradient from '../../assets/images/eunpyeongcare/bg-gradient.png';
import eunpyeongLogo from '../../assets/images/eunpyeongcare/eunpyeong-logo.png';
import headsetImage from '../../assets/images/eunpyeongcare/headset.png';
import soundpillLogo from '../../assets/images/eunpyeongcare/soundpill-logo.png';
import CollabXIcon from '../../components/eunpyeongcare/CollabXIcon';
import GuestInquiryModal from '../../components/modals/GuestInquiryModal';
import SocialLoginButtons from '../../components/socialLogin/SocialLoginButtons';
import { AuthStateContext } from '../../contexts/AuthContext';
import { epLocalStorageHandler, resolveEunpyeongCareCouponCode } from '../../utils/eunpyeongCare';
import './eunpyeongcare-coupon-page.css';

export default function EunpyeongCareCouponPage() {
  const { t } = useTranslation();
  const { setLogout } = useContext(AuthStateContext);
  const [searchParams] = useSearchParams();
  const [isInquiryOpen, setIsInquiryOpen] = useState(false);

  useEffect(() => {
    setLogout();
    epLocalStorageHandler('SET', resolveEunpyeongCareCouponCode(searchParams.get('code')));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- 마운트 시 1회만 실행 (이지레스트 쿠폰 페이지와 동일)
  }, []);

  return (
    <>
      <GuestInquiryModal isOpen={isInquiryOpen} setIsOpen={setIsInquiryOpen} />
      <div className="eunpyeongcare-page">
        <div className="eunpyeongcare-page__shell">
          <section className="eunpyeongcare-page__hero" aria-label="은평구 사운드필 이용권 안내">
            <img src={bgGradient} alt="" className="eunpyeongcare-page__hero-bg" />
            <div className="eunpyeongcare-page__hero-content">
              <div className="eunpyeongcare-page__card-glow" aria-hidden />
              <div className="eunpyeongcare-page__card">
                <div className="eunpyeongcare-page__logos">
                  <div
                    className="eunpyeongcare-page__logo-eunpyeong"
                    role="img"
                    aria-label="북한산큰숲, 은평"
                    style={{ backgroundImage: `url(${eunpyeongLogo})` }}
                  />
                  <CollabXIcon />
                  <img
                    src={soundpillLogo}
                    alt="SoundPill"
                    className="eunpyeongcare-page__logo-soundpill"
                  />
                </div>
                <p className="eunpyeongcare-page__greeting">
                  은평구 주민 여러분,
                  <br />
                  반갑습니다!
                </p>
                <h1 className="eunpyeongcare-page__headline">
                  로그인하면,
                  <br />
                  이용권이 자동 적용돼요
                </h1>
              </div>
              <div className="eunpyeongcare-page__headset-wrap">
                <img src={headsetImage} alt="" className="eunpyeongcare-page__headset" />
              </div>
            </div>
          </section>

          <section className="eunpyeongcare-page__login" aria-label="소셜 로그인">
            <p className="eunpyeongcare-page__login-title">{t('sleepingJelly.socialLogin')}</p>
            <div className="eunpyeongcare-page__social-row">
              <SocialLoginButtons />
            </div>
            <button
              type="button"
              className="eunpyeongcare-page__problem-btn"
              onClick={() => setIsInquiryOpen(true)}
            >
              {t('sleepingJelly.problem')}
            </button>
          </section>
        </div>
      </div>
    </>
  );
}
